import { Box, Button, styled } from "@mui/material";

export const ConfigWrapper = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "start",
    border: `1px solid ${theme.palette.border?.main}`,
    maxWidth: "100%",
    overflowX: "auto",
    background: theme.palette.backgroundColor.main,
    padding: "2em",
    gap: "5em"
}));

export const ButtonWrapper = styled(Button)(({ theme }) => ({
    "&:hover": {
      cursor: "pointer",
    },
    minWidth: "48px",
    height: "48px",
    borderRadius: "50%",
    padding: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }));